import { AddRealtimeListener, ClearRealtimeListener } from '@/constants/mutations.js';
import { GetRealtimeListener } from '@/constants/getters.js';

const defaultState = () => {
  return {
    listenerMap: {
      user: {},
      organization: {},
      system: {},
    },
  };
};

export const state = defaultState;

export const getters = {
  [GetRealtimeListener]: (state) => ({ scope, channel, topic }) => {
    const property = `${channel}:-:${topic || ''}`;
    return state.listenerMap[scope][property];
  },
};

export const mutations = {
  [AddRealtimeListener]: (state, { listener, scope, channel, topic }) => {
    const property = `${channel}:-:${topic || ''}`;
    state.listenerMap[scope][property] = listener;
  },
  [ClearRealtimeListener]: (state, { scope, channel, topic }) => {
    const property = `${channel}:-:${topic || ''}`;
    delete state.listenerMap[scope][property];
  },
};
